<template>
  <div>
    <a-spin
      :spinning="loading.page"
      tip="Preparing Data ...  "
    >
      <a-form :form="form">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Create New pipeline?">
              <a-radio-group
                  buttonStyle="solid"
                  v-decorator="[
                  'create_new',
                  { rules: [{ required: true }], initialValue: initialData.create_new },
                  ]"
                  ref="form_create_new"
                  @change="changeCreateNew"
              >
                <a-radio-button value="0">No</a-radio-button>
                <a-radio-button value="1">Yes</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Pipeline">
              <!-- <a-input
                autocomplete="off" zzz
                v-decorator="['pipeline_id', { rules: [{ required: false }], initialValue: initialData.pipeline_id}]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='1'"
              ></a-input> -->

              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['pipeline_id', { rules: [{ required: false }], initialValue: initialData.pipeline_id}]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='1'"
                @change="changePipelineId"
              >
                <a-select-option
                    v-for="item in pipeline_list"
                    :key="item.pipeline_id"
                  >{{item.pipeline_no}} - {{item.definitions}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Product">
              <a-input
                autocomplete="off"
                v-decorator="['definition', { rules: [{ required: true }], initialValue: initialData.definition }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input>
            </a-form-item>
            <a-form-item label="Description">
              <a-input
                autocomplete="off"
                v-decorator="['description', { rules: [{ required: true }], initialValue: initialData.description }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input>
            </a-form-item>
            <a-form-item label="Customer Name">
              <a-auto-complete
                autocomplete="off"
                v-decorator="['end_user', { rules: [{ required: true }], initialValue: initialData.end_user }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
                class="certain-category-search"
                dropdownClassName="certain-category-search-dropdown"
                :dropdownMatchSelectWidth="false"
                placeholder="input here"
                optionLabelProp="value"
                :filterOption="filterOption"
              >
                <template #dataSource>
                  <a-select-option v-for="cust in custNameList" :key="cust.customer_id" :value="cust.customer_nm.trim()">
                    {{ cust.customer_code }} - {{ cust.customer_nm }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </a-form-item>
            <a-form-item label="Marketing/">
              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['pic', {rules: [{required: true}], initialValue: initialData.pic}]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              >
                <a-select-option
                    v-for="karyawan in akun_Manager"
                    :key="karyawan.tlc"
                  >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="PIMPRO">
              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['pimpro', { rules: [{ required: false }], initialValue: initialData.pimpro }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              >
                <a-select-option
                    v-for="karyawan in getAllKaryawan"
                    :key="karyawan.tlc"
                  >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Contact Details">
              <a-input
                autocomplete="off"
                v-decorator="['contact_details', { rules: [{ required: false }], initialValue: initialData.contact_details }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-row :gutter="16" style="display:none">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Currency">
                  <a-select
                    placeholder="Select Currency"
                    v-decorator="['currency', { rules: [{ required: true }], initialValue: initialData.currency }]"
                    :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
                    class="width-full"
                    initialValue
                    allowClear
                    @change="handleChangeCurrency"
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.code }} - {{ item.currency }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item :label="'Exchange rate'+lblxchangerate">
                  <a-input-number
                    :min="0"
                    class="m-width-full m-text-numberRight"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    :disabled="lblxchangerate=='' || $refs.form_create_new && $refs.form_create_new.value=='0'"
                    v-decorator="['exchange_rate', { rules: [{ required: true }], initialValue: initialData.exchange_rate }]"
                  ></a-input-number>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Est. Contract value (IDR)">
              <a-input-number
                :min="0"
                class="m-width-full m-text-numberRight"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                @change="changeestcontrak"
                v-decorator="['est_contract_value', { rules: [{ required: true }], initialValue: initialData.est_contract_value }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input-number>
            </a-form-item>
            <!-- <a-form-item label="Est. Gross Profit">
              <div style="display: flex;gap:16px">
                <a-input-number
                  type="number"
                  :min="0"
                  :max="100"
                  class="m-text-numberRight" style="width: 30%;"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  @keydown="onlyNumber"
                  @change="changeprosen"
                  v-decorator="['est_gross_profit_prosen', { rules: [{ required: true }], initialValue: initialData.est_gross_profit_prosen }]"
                ></a-input-number>
                  <a-input-number
                    type="number"
                    :min="0"
                    class="m-text-numberRight" style="width: 70%"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    @keydown="onlyNumber"
                    disabled
                    v-decorator="['est_gross_profit', { rules: [{ required: true }], initialValue: initialData.est_gross_profit }]"
                  ></a-input-number>
              </div>
            </a-form-item> -->
            <a-form-item label="Est. Operasional Cost (IDR)">
              <a-input-number
                :min="0"
                class="m-width-full m-text-numberRight"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                
                v-decorator="['est_operasional_cost', { rules: [{ required: true }], initialValue: initialData.est_operasional_cost }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Est. Marketing Cost (IDR)">
              <a-input-number
                :min="0"
                class="m-text-numberRight  m-width-full"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                v-decorator="['est_marketing_cost', { rules: [{ required: true }], initialValue: initialData.est_marketing_cost }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Est. GA Cost (IDR)">
              <a-input-number
                :min="0"
                class="m-text-numberRight  m-width-full"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                v-decorator="['est_ga_cost', { rules: [{ required: true }], initialValue: initialData.est_ga_cost }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Est. Finance Cost (IDR)">
              <a-input-number
                :min="0"
                class="m-text-numberRight  m-width-full"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                
                v-decorator="['est_finance_cost', { rules: [{ required: true }], initialValue: initialData.est_finance_cost }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Status">
              <a-select
                placeholder="Select "
                v-decorator="['status', { rules: [{ required: true }], initialValue: initialData.status }]"
                class="width-full"
                disabled
              >
                <a-select-option value="PROSPECT">Prospect</a-select-option>
                <a-select-option value="CONTRACT">Contract</a-select-option>
                <a-select-option value="LOST">Lost</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Category">
              <a-select
                placeholder="Select Category"
                v-decorator="['category', { rules: [{ required: true }], initialValue: initialData.category }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
                class="width-full"
                initialValue
                allowClear
              >
                <a-select-option
                  v-for="item in kategori"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="Year">
              <a-select
                placeholder="Select "
                v-decorator="['year', { rules: [{ required: true }], initialValue: initialData.year }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
                class="width-full"
              >
                <a-select-option  v-for="n in 5" :key="n-1" :value="Number(moment().format('YYYY'))+(n-1)">{{Number(moment().format('YYYY'))+(n-1)}}</a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item label="Progress">
              <a-row :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                  <a-input-number
                    type="number"
                    :min="0"
                    :max="100"
                    class="m-width-full m-text-numberRight"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    @keydown="onlyNumber"
                    @change="changeProgress"
                    ref="refProgress"
                    v-decorator="['progress', { rules: [{ required: true }], initialValue: initialData.progress }]"
                  ></a-input-number>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
                  <a-progress :percent="initialData.progress" />
                </a-col>
              </a-row>
            </a-form-item> -->
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="4"
                v-decorator="['note', { rules: [{ required: false }], initialValue: initialData.note }]"
                :disabled="$refs.form_create_new && $refs.form_create_new.value=='0'"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import axios from "axios";
  import _ from "lodash";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  export default {
    name: "ProspectNotificationCreate",
    mixins: [CurrencyFormat, GlobalMethod],
    props: ["pipelineSource"],
    data(){
      return {
        loading: {
          page: false,
        },
        akun_Manager: null,
        custNameList:null,
        kategori: null,
        lblxchangerate:"",
        pipeline_list: [],
        pipelineEntryTemp: null
      }
    },
    created() {
      this.form = this.$form.createForm(this);
    },
    mounted(){
      this.$store.dispatch("FETCH_ALL_MATA_UANG");
      this.handleReload()
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getDefaultDateFormat",
        "getStandartFormatDate",
        "getAllMataUang",
        "getAllKaryawan",
      ]),
      initialData(){
        return this.pipelineEntryTemp ?
          {
            create_new: this.pipelineEntryTemp.create_new,
            pipeline_id: this.pipelineEntryTemp.pipeline_id,
            definition: this.pipelineEntryTemp.definitions,
            description: this.pipelineEntryTemp.description,
            end_user: this.pipelineEntryTemp.client,
            pic: this.pipelineEntryTemp.pic_am,
            pimpro: this.pipelineEntryTemp.pic_pimpro,
            contact_details: this.pipelineEntryTemp.contact_detail,
            currency: this.pipelineEntryTemp.currency,
            exchange_rate: this.pipelineEntryTemp.exchange_rate,
            est_contract_value: this.pipelineEntryTemp.est_contract_value,
            est_operasional_cost: this.pipelineEntryTemp.est_operasional_cost,
            est_marketing_cost: this.pipelineEntryTemp.est_marketing_cost,
            est_ga_cost: this.pipelineEntryTemp.est_ga_cost,
            est_finance_cost: this.pipelineEntryTemp.est_finance_cost,
            status: this.pipelineEntryTemp.status,
            category: this.pipelineEntryTemp.kategori,
            year: this.pipelineEntryTemp.year,
            note: this.pipelineEntryTemp.note,
          } : 
          (
          this.pipelineSource ? 
          {
            create_new: this.pipelineSource.create_new,
            pipeline_id: this.pipelineSource.pipeline_id,
            definition: this.pipelineSource.definition,
            description: this.pipelineSource.description,
            end_user: this.pipelineSource.end_user,
            pic: this.pipelineSource.pic,
            pimpro: this.pipelineSource.pimpro,
            contact_details: this.pipelineSource.contact_details,
            currency: this.pipelineSource.currency,
            exchange_rate: this.pipelineSource.exchange_rate,
            est_contract_value: this.pipelineSource.est_contract_value,
            est_operasional_cost: this.pipelineSource.est_operasional_cost,
            est_marketing_cost: this.pipelineSource.est_marketing_cost,
            est_ga_cost: this.pipelineSource.est_ga_cost,
            est_finance_cost: this.pipelineSource.est_finance_cost,
            status: this.pipelineSource.status,
            category: this.pipelineSource.category,
            year: this.pipelineSource.year,
            note: this.pipelineSource.note,
          } :
          {
          create_new: '0',
          pipeline_id: null,
          definition: null,
          description: null,
          end_user: null,
          pic: null,
          pimpro: null,
          contact_details: null,
          currency: 'IDR',
          exchange_rate: '1',
          est_contract_value: null,
          est_operasional_cost: null,
          est_marketing_cost: null,
          est_ga_cost: null,
          est_finance_cost: null,
          status: 'PROSPECT',
          category: null,
          year: null,
          note: null,
        })
      }
    },
    methods:{
      moment,
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      handleRef(){
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
          Event.$emit("ProspectNotifData", { pipeline: values });
        })
      },
      handleChangeCurrency(){

      },
      changeestcontrak(val){
      },
      async handleReload() {
        this.loading.page = true;
        let urlfetch = "getPipelineList";
        await this.$store
          .dispatch(urlfetch, {})
          .then(
            (res) => {
              this.custNameList = res.data.customer;
              this.kategori = res.data.kategori
              this.loading.page = false;
            })
          .catch((error) => {
            let responses = Object.assign({}, error);
            this.displayMessageValue("error-other", responses);
            this.loading.page = false;
          });

          const akunManager = axios({
            method: "get",
            url: this.$serviceUrl + "project/akun_manajer",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey
            }
          }).catch(err => {
            console.log(err);
          });

          const pipelineList = axios({
            method: "get",
            url: this.$serviceUrl + "prospek/pipeline",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey
            }
          }).catch(err => {
            console.log(err);
          });

          return axios
          .all([
            akunManager.catch(err => {
              return null;
            }),
            pipelineList.catch(err => {
              return null;
            }),
          ]
          ).then(response => {
              if (response[0] !== undefined) {
                this.akun_Manager = response[0].data.data
              }
              if (response[1] !== undefined) {
                this.pipeline_list = response[1].data.pipeline
              }
            })
      },
      changePipelineId(value){
        let tempdata = this.pipeline_list.filter(item=>item.pipeline_id==value)
        if(tempdata.length>0){
          this.pipelineEntryTemp = tempdata[0]
          this.pipelineEntryTemp['create_new']=this.$refs.form_create_new.value
        }else{
          this.pipelineEntryTemp = null
        }
      },
      changeCreateNew(val){
        this.pipelineEntryTemp= {
          create_new: val,
          pipeline_id: null,
          definition: null,
          description: null,
          end_user: null,
          pic: null,
          pimpro: null,
          contact_details: null,
          currency: 'IDR',
          exchange_rate: '1',
          est_contract_value: null,
          est_operasional_cost: null,
          est_marketing_cost: null,
          est_ga_cost: null,
          est_finance_cost: null,
          status: 'PROSPECT',
          category: null,
          year: null,
          note: null,
        };
        this.form.resetFields();
      }
    },
  }
</script>